// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import cartPageStyles from "@sc/App/SharedStyles/CartPageStyles";
import { cartActionsStyles } from "@sc/Overrides/Widgets/Cart/CartActions";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        row-gap: 16px;
        flex-wrap: wrap;
        padding-top: 13px;
        margin-bottom: 16px;
        border-top: 1px solid ${color("common.border")};

        ${xScreen("lte", "md")} {
            margin-bottom: 0;
        }
    `,
};
cartActionsStyles.saveOrderLink = {
    ...cartPageStyles.cartActions?.saveOrderLink,
};
cartActionsStyles.addAllToListClickable = {
    ...cartPageStyles.cartActions?.addAllToListClickable,
};
cartActionsStyles.removeAllLink = {
    ...cartPageStyles.cartActions?.removeAll,
};
cartActionsStyles.removeAndAddAllToListWrapper = {
    css: css`
        flex: 1;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
    `,
};
cartActionsStyles.removeAllConfirmationModalStyles = {
    modal: {
        sizeVariant: "medium",
    },
};
